export default "__VITE_ASSET__iKo0vius__"